<template>
	<div>
		<div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Delegacja</h5>
						<button type="button" class="close ms-auto" data-bs-dismiss="modal">
							<span>&times;</span>
						</button>
					</div>

					<div class="modal-body">

						<ul class="nav nav-tabs" role="tablist">
							<li class="nav-item">
								<button class="nav-link active" data-bs-toggle="tab" data-bs-target="#delegacjaTab"
									type="button">
									Delegacja
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#kwotyTab" type="button">
									Pobrane kwoty
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#paliwoTab" type="button">
									Paliwo
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#jedzenieTab"
									type="button">
									Jedzenie
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#hotelTab" type="button">
									Hotel
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#drogiTab" type="button">
									Drogi płatne
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#czesciTab" type="button">
									Części/inne
								</button>
							</li>
						</ul>

						<div class="tab-content pt-3">

							<div class="tab-pane fade show active" id="delegacjaTab">

								<div class="row g-3">

									<div class="col-md-4">
										<label class="form-label">Pracownik</label>
										<ejs-combobox v-model="user_id" :dataSource="usersList" :fields="fields"
											:allowFiltering="true" filterType="Contains"
											placeholder="Wyszukaj pracownika" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Data</label>
										<ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'"
											:value="dateRange" :firstDayOfWeek="1" :weekNumber="true"
											@change="onDateRangeChange" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Numer delegacji</label>
										<input v-model="numer" class="form-control form-control-sm" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Miejsce / klient</label>
										<input v-model="miejsce" class="form-control form-control-sm" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Projekt</label>
										<ejs-combobox v-model="project" :dataSource="projectsList"
											:fields="projectFields" :allowFiltering="true" filterType="Contains"
											placeholder="Wyszukaj projekt" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Cel delegacji</label>
										<ejs-combobox v-model="cel" :dataSource="cele" :fields="celFields"
											:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj cel" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Pojazd</label>
										<ejs-multiselect v-model="pojazd" :dataSource="pojazdy" :fields="pojazdFields" :allowFiltering="true" filterType="Contains" placeholder="Wybierz pojazdy"/>
									</div>

									<div class="col-md-4">
										<label class="form-label">Karta debetowa</label>
										<ejs-combobox v-model="card" :dataSource="karty" :fields="cardFields"
											:allowFiltering="true" filterType="Contains" placeholder="Wyszukaj kartę" />
									</div>

									<div class="col-md-4">
										<label class="form-label">Rozliczony?</label>
										<select v-model="rozliczony" class="form-select form-select-sm">
											<option value="0">Nie</option>
											<option value="1">Tak</option>
										</select>
									</div>

								</div>

							</div>
							<div class="tab-pane fade" id="kwotyTab">
								<div class="row g-2">
									<div v-for="(item, index) in kwotyPobrane" :key="'kwota' + index" class="col-md-4">
										<label class="form-label">Kwota pobrana</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKwota(index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKwota">
									+ Dodaj kwotę
								</button>
							</div>

							<div class="tab-pane fade" id="paliwoTab">
								<div class="row g-2">
									<div v-for="(item, index) in koszty.paliwo" :key="'paliwo' + index"
										class="col-md-4">
										<label class="form-label">Paliwo</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKoszt('paliwo', index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKoszt('paliwo')">
									+ Dodaj paliwo
								</button>
							</div>
							<div class="tab-pane fade" id="jedzenieTab">
								<div class="row g-2">
									<div v-for="(item, index) in koszty.jedzenie" :key="'jedzenie' + index"
										class="col-md-4">
										<label class="form-label">Jedzenie</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKoszt('jedzenie', index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKoszt('jedzenie')">
									+ Dodaj jedzenie
								</button>
							</div>
							<div class="tab-pane fade" id="hotelTab">
								<div class="row g-2">
									<div v-for="(item, index) in koszty.hotel" :key="'hotel' + index" class="col-md-4">
										<label class="form-label">Hotel</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKoszt('hotel', index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKoszt('hotel')">
									+ Dodaj hotel
								</button>
							</div>

							<div class="tab-pane fade" id="drogiTab">
								<div class="row g-2">
									<div v-for="(item, index) in koszty.drogi" :key="'drogi' + index" class="col-md-4">
										<label class="form-label">Drogi płatne</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKoszt('drogi', index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKoszt('drogi')">
									+ Dodaj drogi płatne
								</button>
							</div>

							<div class="tab-pane fade" id="czesciTab">
								<div class="row g-2">
									<div v-for="(item, index) in koszty.czesci" :key="'czesci' + index"
										class="col-md-4">
										<label class="form-label">Części/inne</label>
										<div class="input-group input-group-sm">
											<input v-model="item.kwota" type="number" step="0.01" class="form-control"
												placeholder="0.00" />
											<select v-model="item.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
										</div>
										<div class="mt-1">
											<input v-model="item.data" type="date"
												class="form-control form-control-sm" />
										</div>
										<button type="button" class="btn btn-danger btn-sm mt-1"
											@click="removeKoszt('czesci', index)">
											-
										</button>
									</div>
								</div>
								<button type="button" class="btn btn-success btn-sm mt-2" @click="addKoszt('czesci')">
									+ Dodaj części/inne
								</button>
							</div>

						</div>

					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
							Zamknij
						</button>

						<button type="button" class="btn btn-primary" @click="submit">
							Zapisz
						</button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { ComboBoxComponent, MultiSelectComponent } from "@syncfusion/ej2-vue-dropdowns";

export default {
	props: {
		users: {
			type: [Array, Object],
			default: () => []
		},
		selectedMonth: Number,
		selectedYear: Number,
		currencys: { type: Array, default: () => [] },
		karty: { type: Array, default: () => [] },
		cele: { type: Array, default: () => [] },
		pojazdy: { type: Array, default: () => [] },
		projects: Array
	},

	components: {
		'ejs-daterangepicker': DateRangePickerComponent,
		'ejs-combobox': ComboBoxComponent,
		'ejs-multiselect': MultiSelectComponent
	},

	data() {
		return {
			modalObj: null,
			user_id: null,
			dateRange: [],
			startDate: null,
			endDate: null,
			numer: null,
			miejsce: null,
			card: null,
			pojazd: [],
			rozliczony: 0,
			cel: null,
			project: null,

			kwotyPobrane: [
				{
					kwota: null,
					waluta: 'PLN',
					data: new Date().toISOString().substring(0, 10)
				}
			],

			koszty: {
				paliwo: [
					{
						kwota: null,
						waluta: 'PLN',
						data: new Date().toISOString().substring(0, 10)
					}
				],
				jedzenie: [
					{
						kwota: null,
						waluta: 'PLN',
						data: new Date().toISOString().substring(0, 10)
					}
				],
				hotel: [
					{
						kwota: null,
						waluta: 'PLN',
						data: new Date().toISOString().substring(0, 10)
					}
				],
				drogi: [
					{
						kwota: null,
						waluta: 'PLN',
						data: new Date().toISOString().substring(0, 10)
					}
				],
				czesci: [
					{
						kwota: null,
						waluta: 'PLN',
						data: new Date().toISOString().substring(0, 10)
					}
				]
			},

			fields: {
				text: 'full_name',
				value: 'id'
			},

			projectFields: {
				text: 'number',
				value: 'id'
			},

			cardFields: {
				text: 'name',
				value: 'name'
			},

			celFields: {
				text: 'name',
				value: 'name'
			},
			pojazdFields: {
				text: 'nr_rejestracyjny',
				value: 'nr_rejestracyjny'
			}
			};
	},

	computed: {
	   usersList() {
			return (this.users || []).map(u => ({
				id: Number(u.id),
				full_name: `${u.first_name || ''} ${u.last_name || ''}`.trim()
			}));
		},

		projectsList() {
			return (this.projects || []).map(p => ({
				id: p.id,
				number: `${p.number}`
			}));
		}
	},
	
	watch: {
		miejsce(newValue) {

			if (!this.numer && this.startDate) {
				this.generateNumer();
				return;
			}

			this.updateNumerKod(newValue);
		}
	},
	mounted() {
		this.modalObj = new Modal(this.$refs.modalEle);

		this.$refs.modalEle.addEventListener('show.bs.modal', () => {

			this.resetForm();

		});

		this.$refs.modalEle.addEventListener('hide.bs.modal', () => {

			this.resetForm();

		});
	},
	created() {
		const today = new Date();
		this.dateRange = [today, today];
		this.onDateRangeChange({ value: this.dateRange });
	},

  methods: {
	resetForm() {
		this.user_id = null;
		this.project = null;
		this.miejsce = null;
		this.card = null;
		this.cel = null;
		this.pojazd = [];
		this.rozliczony = 0;

		this.numer = null;

		const today = new Date();

		this.dateRange = [today, today];

		this.onDateRangeChange({
			value: this.dateRange
		});
	},

	updateNumerKod(miejsce) {

		if (!this.numer) {

			if (this.startDate) {
				this.generateNumer();
			}

			return;
		}


		const parts = this.numer.split('/');

		if (parts.length < 5) {
			return;
		}


		const kod = miejsce
			? miejsce.trim().substring(0, 2).toUpperCase()
			: '';


		parts[4] = kod;

		this.numer = parts.join('/');
	},

		async generateNumer() {
			if (!this.startDate) {
				return;
			}

			try {
				const response = await axios.post('/kadry/delegacje/generate-numer', {
					date: this.startDate,
					miejsce: this.miejsce || null
				});

				this.numer = response.data.numer;

				// Po wygenerowaniu numeru dopisz kod miejsca
				this.updateNumerKod(this.miejsce);

			} catch (error) {
				console.error('Błąd generowania numeru delegacji:', error);
			}
		},
		
		async onDateRangeChange(args) {
			const [start, end] = args.value || [];

			this.startDate = start ? this.formatDateToYMD(start) : null;
			this.endDate = end ? this.formatDateToYMD(end) : null;

			if (this.startDate) {
				await this.generateNumer();
			}
		},

		formatDateToYMD(date) {
			if (!date) return null;

			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, "0");
			const d = String(date.getDate()).padStart(2, "0");

			return `${y}-${m}-${d}`;
		},

		addKwota() {
			this.kwotyPobrane.push({
				kwota: null,
				waluta: 'PLN',
				data: new Date().toISOString().substring(0, 10)
			});
		},

		removeKwota(index) {
			if (this.kwotyPobrane.length > 1) {
				this.kwotyPobrane.splice(index, 1);
			}
		},

		addKoszt(type) {
			this.koszty[type].push({
				kwota: null,
				waluta: 'PLN',
				data: new Date().toISOString().substring(0, 10)
			});
		},

		removeKoszt(type, index) {
			if (this.koszty[type].length > 1) {
				this.koszty[type].splice(index, 1);
			}
		},

		async submit() {
		
		
    console.log('user_id:', this.user_id);
    console.log('usersList:', this.usersList);


			if (!this.user_id) {
				this.errorMsg("Wybierz pracownika.");
				return;
			}

			if (!this.startDate || !this.endDate) {
				this.errorMsg("Wybierz zakres dat.");
				return;
			}

			const payload = {
				user_id: this.user_id,
				startDate: this.startDate,
				endDate: this.endDate,
				numer: this.numer,
				miejsce: this.miejsce,
				cel: this.cel,
				card: this.card,
				pojazd: this.pojazd,
				rozliczony: this.rozliczony,
				project: this.project,

				kwotyPobrane: this.kwotyPobrane
					.filter(k => k.kwota > 0)
					.map(k => ({
						kwota: k.kwota,
						waluta: k.waluta,
						data: k.data
					})),

				koszty: {
					paliwo: this.koszty.paliwo
						.filter(k => k.kwota > 0)
						.map(k => ({
							kwota: k.kwota,
							waluta: k.waluta,
							data: k.data
						})),

					jedzenie: this.koszty.jedzenie
						.filter(k => k.kwota > 0)
						.map(k => ({
							kwota: k.kwota,
							waluta: k.waluta,
							data: k.data
						})),

					hotel: this.koszty.hotel
						.filter(k => k.kwota > 0)
						.map(k => ({
							kwota: k.kwota,
							waluta: k.waluta,
							data: k.data
						})),

					drogi: this.koszty.drogi
						.filter(k => k.kwota > 0)
						.map(k => ({
							kwota: k.kwota,
							waluta: k.waluta,
							data: k.data
						})),

					czesci: this.koszty.czesci
						.filter(k => k.kwota > 0)
						.map(k => ({
							kwota: k.kwota,
							waluta: k.waluta,
							data: k.data
						}))
				},

				selectedYear: this.selectedYear,
				selectedMonth: this.selectedMonth + 1
			};

			this.$emit("save-delegacja", payload);
			this.hide();
		},

		successMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'success',
				title: 'Sukces!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},

		errorMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'warning',
				title: 'Błąd!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},

		show() {
			if (this.modalObj) this.modalObj.show();
		},

		hide() {
			if (this.modalObj) this.modalObj.hide();
		}
	}
};
</script>

<style>
.position-absolute {
	background: white;
	max-height: 200px;
	overflow-y: auto;
	border: 1px solid #ddd;
}
</style>